import { TDaysSettings, TOnboardingRhythmValues } from "@/types";

export const DefaultDaysSettings: TDaysSettings = {
	monday: {
		hours: undefined,
		isWorkingDay: false,
	},
	tuesday: {
		hours: undefined,
		isWorkingDay: false,
	},
	wednesday: {
		hours: undefined,
		isWorkingDay: false,
	},
	thursday: {
		hours: undefined,
		isWorkingDay: false,
	},
	friday: {
		hours: undefined,
		isWorkingDay: false,
	},
	saturday: {
		hours: undefined,
		isWorkingDay: false,
	},
	sunday: {
		hours: undefined,
		isWorkingDay: false,
	},
};

/**
 * What a new account gets when it skips the "work rhythm" onboarding
 * step: a standard Monday–Friday week at 7h/day. Deliberately not
 * `DefaultDaysSettings` (no working day at all) — that shape is the
 * blank form, not a usable rhythm.
 */
export const OnboardingDefaultRhythm: TOnboardingRhythmValues = {
	workDays: {
		...DefaultDaysSettings,
		monday: { hours: "07:00", isWorkingDay: true },
		tuesday: { hours: "07:00", isWorkingDay: true },
		wednesday: { hours: "07:00", isWorkingDay: true },
		thursday: { hours: "07:00", isWorkingDay: true },
		friday: { hours: "07:00", isWorkingDay: true },
	},
	hoursPerDay: "07:00",
};
